module.exports = __webpack_public_path__ + "static/2-IMG-5778-67fbef277c273cc8774d21fefee16a4d.jpg";